import { z } from "zod";
import { InstantRangeSchema } from "@thalamos/common";
export const InterviewContactMethodSchema = z.enum([
    "email",
    "sms",
    "manual",
    "call",
]);
export const CreateInterviewInputSchema = z.object({
    formContextId: z.uuid(),
    address: z.string().max(500).nullable().optional(),
    postalCode: z.string().max(10).nullable().optional(),
    locationUnknown: z.boolean().optional().default(false),
    timeRanges: z.array(InstantRangeSchema).optional().default([]),
});
export const UpdateInterviewInputSchema = z.object({
    address: z.string().max(500).nullable().optional(),
    postalCode: z.string().max(10).nullable().optional(),
    locationUnknown: z.boolean().optional(),
    timeRanges: z.array(InstantRangeSchema).optional(),
    status: z.enum(["created", "confirmed", "cancelled"]).optional(),
});
export const AddInterviewParticipantInputSchema = z.object({
    userId: z.uuid(),
    teamId: z.uuid().optional(),
    status: z.enum(["pending", "pending-confirmed"]).optional(),
    contactMethod: z.array(InterviewContactMethodSchema).optional(),
    inviteSource: z.enum(["known", "search"]).optional(),
});
export const INVITATION_WITHDRAWN_REASON = "Invitation withdrawn";
export const INTERVIEW_INVITE_PREDEFINED_REJECTION_REASONS = [
    "Availability incorrect",
    "Received in error",
    "Otherwise occupied",
    "Conflict of interest",
    "Not correct specialism",
    "Other",
];
const interviewInvitePredefinedRejectionReasonSet = new Set(INTERVIEW_INVITE_PREDEFINED_REJECTION_REASONS);
export function isInterviewInvitePredefinedRejectionReason(rejectionReason) {
    return interviewInvitePredefinedRejectionReasonSet.has(rejectionReason);
}
export function sanitiseInterviewInviteRejectionReasonForEmail(rejectionReason) {
    const trimmedRejectionReason = rejectionReason?.trim();
    if (!trimmedRejectionReason) {
        return undefined;
    }
    if (isInterviewInvitePredefinedRejectionReason(trimmedRejectionReason)) {
        return trimmedRejectionReason;
    }
    return "Other";
}
export const ConfirmParticipantInputSchema = z.object({
    noteToDoctor: z.string().max(1000).nullable().optional(),
});
export const RejectInterviewInviteInputSchema = z.object({
    rejectionReason: z.string().max(1000).optional(),
});
export const AcceptInterviewInviteInputSchema = z.object({
    selectedTimeRange: InstantRangeSchema.nullable().optional(),
});
//# sourceMappingURL=interview.js.map